module.exports = __webpack_public_path__ + "img/6.74719c4d.png";